import { render, staticRenderFns } from "./PreviewLabelReport.vue?vue&type=template&id=331ba6ee"
import script from "./PreviewLabelReport.vue?vue&type=script&lang=js"
export * from "./PreviewLabelReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports